// extracted by mini-css-extract-plugin
export default {"bar":"ProgressBar__bar___AvWIq","bg":"ProgressBar__bg___UVITD","inner":"ProgressBar__inner___tiC7F","blue":"ProgressBar__blue___VMO9o","red":"ProgressBar__red___xl495"};